import * as React from "react"
const DesignSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      enableBackground: "new 0 0 122.88 94.35",
    }}
    viewBox="-30 -50 180 180"
    {...props}
  >
    <path
      d="M90.37 26.48h25.48c1.94 0 3.71.79 4.97 2.06a7.008 7.008 0 0 1 2.06 4.97v53.82c0 1.94-.79 3.71-2.06 4.97a7.008 7.008 0 0 1-4.97 2.06H90.37c-1.94 0-3.71-.79-4.97-2.06a7.008 7.008 0 0 1-2.06-4.97V33.5c0-1.94.79-3.71 2.06-4.97a6.981 6.981 0 0 1 4.97-2.05zM3.05 0h106.12c1.68 0 3.05 1.37 3.05 3.05v18.44h-6.48V8.44c0-1.48-1.21-2.7-2.7-2.7H9.17c-1.48 0-2.7 1.21-2.7 2.7v52.53c0 1.48 1.21 2.7 2.7 2.7H76.7V76.4H3.05C1.37 76.4 0 75.03 0 73.35V3.05C0 1.37 1.37 0 3.05 0zm39.22 80.61h27.67c.07 4.79 2.04 9.07 7.39 12.45H34.89c4.27-3.1 7.4-6.87 7.38-12.45zm13.84-14.49a3.92 3.92 0 0 1 3.92 3.92c0 2.16-1.76 3.92-3.92 3.92a3.92 3.92 0 1 1 0-7.84zm46.99 19.6c1.59 0 2.89 1.28 2.89 2.89 0 1.59-1.28 2.89-2.89 2.89-1.59 0-2.89-1.28-2.89-2.89 0-1.59 1.28-2.89 2.89-2.89zm-16.8-2.2h33.61V37.37H86.3v46.15z"
      fill={'whitesmoke'}
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
      }}
    />
  </svg>
)
export default DesignSVG
